/* eslint id-length: off */
import jQuery from 'jquery';
import 'jquery-migrate';
window.jQuery = jQuery;
window.$ = jQuery;
